import carBg from './img/car-bg.png';
import { useState, useEffect, useRef } from 'react'
import './App.css';
import { ImageBuilder } from './components/ImageBuilder/ImageBuilder';
import { PlateOptions } from './components/PlateOptions/PlateOptions';
import { DispatchMessage } from './components/DispatchMessage/DispatchMessage';
import { ResultPrice } from './components/ResultPrice/ResultPrice';
import { initialChoosedOptionsContext } from './store/initial-plate-option';
import domtoimage from 'dom-to-image-more';
import { colorize } from './components/Options/Popups/CustomBadgePopup/iconsBadge';
import { ErrorModal } from './components/UI/ErrorModal';

let devtoolsOpen = false;

function App({ plateBuilder }) {
  const currentUrl = window.location.protocol + '//' + window.location.host + window.location.pathname
  const searchParams = new URLSearchParams(document.location.search)
  const [ChoosedOptions, setChoosedOptions] = useState(initialChoosedOptionsContext)
  const [activeClassName, setActiveClassName] = useState(true)
  const [defaultName, setDefaultName] = useState(true)
  const inputRef = useRef(null);
  const [activePopup, setActivePopup] = useState(null)
  const [isValid, setIsValid] = useState({
    isValid: true,
    typePlate: 'standard'
  });

  useEffect(() => {
    if (ChoosedOptions.typeOfTransport == "motorbike") {
      setChoosedOptions((prevState) => ({
        ...prevState,
        frontPlate: "false",
      }))
    }
    ChoosedOptions.registrationName.length === 0 ? setDefaultName(true) : setDefaultName(false)
    if(ChoosedOptions.fontStyle === 'null' && ChoosedOptions.typeOfTransport === 'motorbike') {
      setChoosedOptions((prevState) => ({
        ...prevState,
        fontStyle: "CharlesWright Motorcycle",
      }))
    }
    const threshold = 160;

    const checkDevTools = () => {
      const widthThreshold = window.outerWidth - window.innerWidth > threshold;
      const heightThreshold = window.outerHeight - window.innerHeight > threshold;
    
      if (widthThreshold || heightThreshold) {
        if (!devtoolsOpen) {
          devtoolsOpen = true;
          alert("DevTools detected! Please close it.");
          document.querySelector('html').style.pointerEvents = 'none'
          if (window.open('', '_self')) {
            window.close();
          }
        }
      } else {
        if (devtoolsOpen) {
          devtoolsOpen = false;
          window.location.reload()
          document.querySelector('html').style.pointerEvents = 'all'
        }
      }
    };
    
  
    
  
  }, [])
  useState(() => {
    
    if (ChoosedOptions.plateMaterial !== "null") {
      plateBuilder["plate-type"].map((item) => {
        if (item.type.includes(ChoosedOptions.plateMaterial)) {
          if (item.design === "false" || item.design === false) {
            updateChoosedOptions({ designRequired: "hide" });
          }
        }
      });
    } else {
      plateBuilder["plate-type"].map((item) => {
        if (item.type.includes('Regular')) {
          if (item.design === "false" || item.design === false) {
            updateChoosedOptions({ designRequired: "hide" });
          }
        }
      });
    }
  }, [ChoosedOptions]);

  useEffect(() => {
    setActiveClassName(ChoosedOptions.categoryPlate.includes("standard") ? true : false)
    for (const [key, value] of Object.entries(ChoosedOptions)) {
      if (key !== 'frontPlateImg' && key !== 'rearPlateImg' && key !== 'customBadgeLeft' && key !== 'customBadgeRight') {
        searchParams.set(key, value)
      }
    }
    window.history.replaceState('', '', currentUrl + '?' + searchParams.toString())

  }, [ChoosedOptions]);
  useEffect(() => {
    changeColorRightSvg()
    changeColorLeftSvg()

    if (searchParams.get('hasCustomBadgeLeft') === 'true') {
      domtoimage.toPng(document.querySelector('.badge-left'))
        .then(function (dataUrl) {
          setChoosedOptions((prevState) => ({
            ...prevState,
            customBadgeLeft: dataUrl, 
          }));
        })
        .catch(function (error) {
          console.error('Error generating image for left badge:', error);
        });
    }
    
    if (searchParams.get('hasCustomBadgeRight') === 'true') {
      domtoimage.toPng(document.querySelector('.badge-right'))
        .then(function (dataUrl) {
          setChoosedOptions((prevState) => ({
            ...prevState,
            customBadgeRight: dataUrl, 
          }));
        })
        .catch(function (error) {
          console.error('Error generating image for right badge:', error);
        });
    }
    

  }, [
    ChoosedOptions.customBadgeImageLeft,
    ChoosedOptions.customBadgeImageRight,
    ChoosedOptions.customBadgeImageLeft,
    ChoosedOptions.customBadgeImageRight,
    ChoosedOptions.customBadgeTextLeft,
    ChoosedOptions.customBadgeIconColorLeft,
    ChoosedOptions.customBadgeIconColorRight,
    ChoosedOptions.customBadgeColorizeLeft,
    ChoosedOptions.customBadgeColorizeRight,
    ChoosedOptions.customBadgeTextRight,
    ChoosedOptions.customBadgeFontLeft,
    ChoosedOptions.customBadgeFontRight,
    ChoosedOptions.customBadgeTextColorLeft,
    ChoosedOptions.customBadgeTextColorRight,
    ChoosedOptions.customBadgeRotationLeft,
    ChoosedOptions.customBadgeRotationRight,
  ])

  function updateChoosedOptions(value) {
    setChoosedOptions((prevState) => ({
      ...prevState,
      ...value,
    }))
  }

  const onHandlerValid = (value) => {
    setIsValid({
      isValid: value.isValid,
      typePlate: value.typePlate,
      list: value.list
    })
  }
  const onHandlerOpenPopup = (popup) => {
    setActivePopup(popup)
  }
  const handlerAddFocus = () => {
    inputRef.current.focus()
  }
  const findFontStyle = (category) => {
    return plateBuilder['font-family'].find((item) => {
      if (ChoosedOptions.plateMaterial !== 'null') {
        return item.category.includes(category) && item.font === ChoosedOptions.fontStyle && item.material.includes(ChoosedOptions.plateMaterial)
      }
      return item.category.includes(category) && item.font === ChoosedOptions.fontStyle
    })
  }
  const findMaterial = (category) => {
    return plateBuilder['plate-type'].find((item) => {
      return item.category.includes(category) && item.typeOfTransport.includes(ChoosedOptions.typeOfTransport) && item.type === ChoosedOptions.plateMaterial
    })
  }
  const findFrontSize = (category) => {
    const material = ChoosedOptions.plateMaterial !== 'null' ? ChoosedOptions.plateMaterial : 'Regular'
    return plateBuilder['plate-size'].find((item) => {
      return item.category.includes(category) &&
        item.typeOfTransport.includes(ChoosedOptions.typeOfTransport) &&
        item.material.includes(material) && item.size === ChoosedOptions.plateSizeFront
    })
  }
  const findRearSize = (category) => {
    const material = ChoosedOptions.plateMaterial !== 'null' ? ChoosedOptions.plateMaterial : 'Regular'
    return plateBuilder['plate-size'].find((item) => {
      return item.category.includes(category) &&
        item.typeOfTransport.includes(ChoosedOptions.typeOfTransport) &&
        item.material.includes(material) && item.size === ChoosedOptions.plateSizeRear
    })
  }
  const openModalFormCategory = (category) => {
    let list = {}
    if (category.includes("standard")) {
      let regValidLegal = (/(^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$)/g.test(ChoosedOptions.registrationName))
      let length = ChoosedOptions.registrationName.length
      if (length > 0 && length < 3) {
        regValidLegal = /^[A-Za-z\s]*$/.test(ChoosedOptions.registrationName)
      } else if (length >= 3 && length < 5) {
        regValidLegal = /^[0-9]*$/.test(ChoosedOptions.registrationName.slice(2, 4))
      } else if (length >= 5 && length < 9) {
        regValidLegal = /^[A-Za-z\s]*$/.test(ChoosedOptions.registrationName.slice(4, 8))
      }
      if (!regValidLegal) {
        list.regname = `Registration Name is invalid : remove`
      }
    }
    if (ChoosedOptions.plateMaterial !== 'null') {
      const findActiveMaterial = findMaterial(category)
      if (!findActiveMaterial) {
        list.material = `Plate Material: ${ChoosedOptions.plateMaterial}`
      }
    }
    if (ChoosedOptions.fontStyle !== 'null') {
      const findActivefontStyle = findFontStyle(category)
      if (!findActivefontStyle) {
        list.font = `Font Style: ${ChoosedOptions.fontStyle}`
      }
    }
    if (ChoosedOptions.plateSizeFront !== 'null') {
      const findActiveFrontSize = findFrontSize(category)
      if (!findActiveFrontSize && ChoosedOptions.frontPlate === 'true') {
        list.frsize = `Front Plate Size: ${ChoosedOptions.plateSizeFront}`
      }
    }
    if (ChoosedOptions.plateSizeRear !== 'null') {
      const findActiveRearSize = findRearSize(category)
      if (!findActiveRearSize && ChoosedOptions.rearPlate === 'true') {
        list.rrsize = `Rear Plate Size: ${ChoosedOptions.plateSizeRear}`
      }
    }
    if (ChoosedOptions.showBSAU === 'true') {
      list.bsau = `BSAU mark: hide`
    }
    if (ChoosedOptions.showBSAU !== 'true') {
      list.bsau = `BSAU mark: show`
    }
    if (ChoosedOptions.sloganName === 'Plate Mate, JE2 3RD') {
      list.slogan = `Slogan name: hide`
    }
    if (ChoosedOptions.sloganName !== 'Plate Mate, JE2 3RD') {
      list.slogan = `Slogan name: change on "Plate Mate, JE2 3RD"`
    }
    if (ChoosedOptions.sloganFont !== '6px') {
      list.sloganSize = `Slogan size: change`
    }
    if (ChoosedOptions.fontColor !== 'black') {
      list.numberColor = `Number color: change on black`
    }
    if (ChoosedOptions.sloganColor !== 'black') {
      list.sloganColor = `Slogan color: change on black`
    }
    if (ChoosedOptions.badgeRight !== 'null') {
      list.badgeRight = `Badge Right: remove`
    }
    if (ChoosedOptions.hasCustomBadgeLeft !== 'false') {
      list.cbadgeLeft = `Custom Badge Left: remove`
    }
    if (ChoosedOptions.hasCustomBadgeRight !== 'false') {
      list.cbadgeRight = `Custom Badge Right: remove`
    }
    if (ChoosedOptions.designRequired === 'true') {
      list.designRequired = `designRequired: not available`
    }
    if (Object.keys(list).length !== 0) {
      onHandlerValid({
        isValid: false,
        typePlate: 'list-change',
        list: list
      })
    }
  }
  const isDefaultName = (value) => {
    setDefaultName(value)
  }
  const changeColorLeftSvg = () => {
    const elements = document.querySelectorAll(".badge-left .colorize");

    if (elements.length > 0 && ChoosedOptions.customBadgeIconColorLeft) {
      elements.forEach((path) => {
        path.setAttribute("fill", ChoosedOptions.customBadgeIconColorLeft);
      });
    }

  }
  const changeColorRightSvg = () => {
    const elements = document.querySelectorAll(".badge-right .colorize");

    if (elements.length > 0 && ChoosedOptions.customBadgeIconColorRight) {
      elements.forEach((path) => {
        path.setAttribute("fill", ChoosedOptions.customBadgeIconColorRight);
      });
    }

  }
  return (
    <>
      {!isValid.isValid && (<ErrorModal updateChoosedOptions={updateChoosedOptions} addFocus={handlerAddFocus} choosedOptions={ChoosedOptions} closeModal={onHandlerValid} list={isValid.list} messageType={isValid.typePlate}></ErrorModal>)}
      <section className="plate-builder">
        <div className='hidden-block'>
          <div className={(ChoosedOptions.customBadgeRotationLeft === 'true' && 'rotate-image') + ' badge badge-left flex flex-col justify-between'} style={{ "background-color": ChoosedOptions.badgeColorLeft !== 'null' && ChoosedOptions.badgeColorLeft, "color": ChoosedOptions.customBadgeTextColorLeft !== 'null' && ChoosedOptions.customBadgeTextColorLeft, }}>
            {ChoosedOptions.customBadgeColorizeLeft === "false" &&
              <div className='badge-image'>
                {ChoosedOptions.customBadgeImageLeft !== "null" &&
                  <img width="58" height="31" src={require(`./${ChoosedOptions.customBadgeImageLeft}`)} alt=" custom badge" />
                }
              </div>
            }
            {ChoosedOptions.customBadgeColorizeLeft === "true" &&
              colorize.map((item) => {
                if (item.id === ChoosedOptions.customBadgeImageLeft) {
                  return <div onClick={changeColorLeftSvg()}  style={{ "color": ChoosedOptions.customBadgeIconColorLeft }} className='badge-image' dangerouslySetInnerHTML={{ __html: item.svg }}></div>
                }
              })
            }
            <p style={{ "--font-size": 460 / ChoosedOptions.customBadgeTextLeft.length * 1.35 > 6 ? 460 / ChoosedOptions.customBadgeTextLeft.length * 1.35 + 'px' : '80px', 'font-family': ChoosedOptions.customBadgeFontLeft }}>{ChoosedOptions.customBadgeTextLeft} </p>
          </div>
          <div className={(ChoosedOptions.customBadgeRotationRight === 'true' && 'rotate-image') + ' badge badge-right flex flex-col justify-between'} style={{ "background-color": ChoosedOptions.badgeColorRight !== 'null' && ChoosedOptions.badgeColorRight, "color": ChoosedOptions.customBadgeTextColorRight !== 'null' && ChoosedOptions.customBadgeTextColorRight, }}>
            {ChoosedOptions.customBadgeColorizeRight === "false" &&
              <div className='badge-image'>
                {ChoosedOptions.customBadgeImageRight !== "null" &&
                <img width="58" height="31" src={require(`./${ChoosedOptions.customBadgeImageRight}`)} alt=" custom badge" />
                }
              </div>
            }
            {ChoosedOptions.customBadgeColorizeRight === "true" &&
              colorize.map((item) => {
                if (item.id === ChoosedOptions.customBadgeImageRight) {
                  return <div onClick={changeColorRightSvg()} className='badge-image' style={{ "color": ChoosedOptions.customBadgeIconColorRight }} dangerouslySetInnerHTML={{ __html: item.svg }}></div>
                }
              })
            }
            <p style={{ "--font-size": 460 / ChoosedOptions.customBadgeTextRight.length * 1.35 > 6 ? 460 / ChoosedOptions.customBadgeTextRight.length * 1.35+ 'px' : '80px', 'font-family': ChoosedOptions.customBadgeFontRight }}>{ChoosedOptions.customBadgeTextRight} </p>
          </div>
        </div>
        <div className="plate-builder__bg">
          <img width="1920" height="940" src={carBg} alt="Car bg" />
        </div>
        <div className='plate-builder__wrapper'>
          <div className="plate-builder__title">
            <h1>Plate Builder</h1>
          </div>
          <div className="plate-builder__categories-plates flex">
            <div onClick={() => openModalFormCategory('standard')}
              className={activeClassName ? ' plate-builder__categories-plate plate-builder__categories-plate--active' : ' plate-builder__categories-plate'}>Road Compliant Plates</div>
            <div onClick={() => openModalFormCategory('show')} className={!activeClassName ? ' plate-builder__categories-plate plate-builder__categories-plate--active' : ' plate-builder__categories-plate'}>Show Plates</div>
          </div>
          <div className='plate-builder__flex lg:flex items-start'>
            <div className="loader-wr"></div>
            <div className='loader'></div>
            <ImageBuilder plateBuilder={plateBuilder} defaultName={defaultName} isValid={isValid} checkValid={onHandlerValid} openPopup={onHandlerOpenPopup} activePopup={activePopup} updateChoosedOptions={updateChoosedOptions} choosedOptions={ChoosedOptions}></ImageBuilder>
            <PlateOptions plateBuilder={plateBuilder} isDefaultName={isDefaultName} isValid={isValid} checkValid={onHandlerValid} openPopup={onHandlerOpenPopup} activePopup={activePopup} addFocus={handlerAddFocus} inputRef={inputRef} updateChoosedOptions={updateChoosedOptions} choosedOptions={ChoosedOptions}></PlateOptions>
          </div>
          <div className='plate-builder__flex lg:flex justify-end'>
            <DispatchMessage></DispatchMessage>
            <ResultPrice isDefaultName={isDefaultName} isValid={isValid} checkValid={onHandlerValid} openPopup={onHandlerOpenPopup} updateChoosedOptions={updateChoosedOptions} activePopup={activePopup} addFocus={handlerAddFocus} choosedOptions={ChoosedOptions}></ResultPrice>
          </div>
        </div>
      </section>
    </>
  );
}

export default App;